import logo from "../components/logo.png";
import "../styles/Menu1.css";

export default function Contacto() {
  return (
    <div className="metodo-container">
      <div className="metodo-text">

        <h2 style={{ marginBottom: 24 }}>CONTACTO M3 CAMPUS</h2>

            <p style={{ marginBottom: 24 }}>
              Correo electrónico:{" "}
              <a
                href="mailto:meditav@meditav.xyz"
                style={{ color: "#000", textDecoration: "none", fontWeight: 700 }}
              >
               meditav@meditav.xyz
                </a>
                </p>

        <div style={{ textAlign: "center", marginTop: 40, marginBottom: 20 }}>
          <img
            src={logo}
            alt="Logo M3"
            style={{ width: "220px", maxWidth: "80%", height: "auto" }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 16 }}>

          <a
            href="https://wa.me/34614855708"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "#25D366", textDecoration: "none", fontWeight: 700 }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
              alt="WhatsApp"
              style={{ width: 28, height: 28 }}
            />
            +34 614 855 708
          </a>

          <a
            href="https://www.instagram.com/m3campus"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "#E1306C", textDecoration: "none", fontWeight: 700 }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
              alt="Instagram"
              style={{ width: 28, height: 28 }}
            />
            @m3campus
          </a>

        </div>

      </div>
    </div>
  );
}
